const companies = {
  firestorePath: 'companies',
  firestoreRefType: 'collection',
  moduleName: 'companies',
  statePropName: 'data',
  namespaced: true,
  fetch: {
    docLimit: 0, // 0 = no limit (library default is 50)
  },
  state: {},
  getters: {
    array: (state) => {
      const arr = Object.values(state.data);
      return arr.sort((a, b) => {
        const an = (a.name || '').toLowerCase();
        const bn = (b.name || '').toLowerCase();
        if (an < bn) return -1;
        if (an > bn) return 1;
        return 0;
      });
    },
    byId: (state) => (id) => state.data[id],
    byName: (state) => (name) => {
      if (!name) return null;
      const needle = String(name).toLowerCase();
      return Object.values(state.data).find(
        (c) => (c.name || '').toLowerCase() === needle
      ) || null;
    },
  },
  mutations: {},
  actions: {},
};

export default companies;
